<template>
  <main-content>
    <div class="container">
      <div class="row margin-above">
        <div class="col-md-8 mx-auto text-center">
          <div class="card bg-success text-center border-rounded mb-4 p-4" v-if="get_status == 2 || get_status == 5">
            <h4 class="text-white">{{ $t('wallets.receipt.wallet_charge_success') }}</h4>
          </div>
          <div class="card bg-danger text-center border-rounded mb-4 p-4" v-else>
            <h4 class="text-white">{{ $t('wallets.receipt.wallet_charge_fail') }}</h4>
          </div>
        </div>
      </div>
      <div class="row">
        <div class="col-md-6 mx-auto text-center">
            <router-link to="/wallets" class="btn btn-success">{{ $t('wallets.receipt.back_to_wallet') }}</router-link>
        </div>
      </div>
    </div>
  </main-content>
</template>

<script>
import MainContent from "@/components/main-content";
import {
  walletTransactionStatus,
  walletTransactionStatusStr,
} from "@/constants/walletTransactionStatus";
import { walletService } from '@/common/api.service';
export default {
  name: "walletCheckStatus",
  data() {
    return {
      walletTransactionStatus,
      walletTransactionStatusStr,
      get_status: null
    };
  },
  components: {
    MainContent,
  },
  async mounted() {
    await walletService.getSettlementDetailAyande(this.$route.params.id).then(response => {
      this.get_status = response.data.data.status
    })
  },
};
</script>

<style scoped>
.margin-above {
  margin: 14rem 0 0 0;
}
</style>
